<ng-container *transloco="let t">
      <div class="pt-20 pb-16">
            <section>
                @if (favoriteEvents.length ?? 0 > 0  || isFilterActive || isLoading) {
                <app-public-search-filter [filterBy]="['sports', 'country', 'length']"
                                          [countries]="countries"
                                          [sports]="sports"
                                          [lengthRanges]="lengthRanges"
                                          [handleQueryParamsChange]="true"
                                          (onFilterChange)="filterChanged($event)">
                </app-public-search-filter>
                <app-loader [isLoading]="isLoading"></app-loader>
                @if (!(favoriteEvents.length ?? 0 > 0 ) && isFilterActive) {
                <app-empty-state [contentKeys]="['empty.state.profile.no.saved.title']"
                                 [contentKeysSecondary]="['empty.state.profile.no.saved.search']"
                                 [backgroundColor]="'white'" [paddingBottom]="'300px'"
                                 [imgSrc]="'save-light.svg'"/>
                }
                @else {
                  <app-event-grid-list [events]="favoriteEvents!"
                                       (scrolled)="loadMore()"
                                       (onRightButtonClickCallback)="goToEventDetailsPage($event)"
                                       [languages]="languages"/>
                }
                } @else if (!isLoading) {
                  <app-empty-state [contentKeys]="['empty.state.profile.no.saved.title']"
                                   [contentKeysSecondary]="['empty.state.profile.no.saved.description']"
                                   [backgroundColor]="'white'"
                                   [imgSrc]="'save-light.svg'" [paddingBottom]="'300px'"
                                   [buttonText]="'app.common.browse.events'" (onButtonClick)="goToEventCalendar()"/>
                }
            </section>
        </div>

</ng-container>

